import React from 'react';
import { Box, Button, Grid, Typography } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { useHistory } from "react-router-dom";  // ✅ Only this for React Router v5

const HeroSection = () => {
     const history = useHistory();
     const demoVideo = '/images/demo.mp4';
  return (
    <Box p={5} style={{ backgroundColor: '#f7f9fc'}}>
      <Grid container spacing={4} alignItems="center">
        {/* Left Content */}
        <Grid item xs={12} md={6}>
          <Typography variant="h2" style={{ fontWeight: 'bold', marginBottom: 16 }}>
            Exclusive Montessori methodology, <br />
            based application for Montessori schools
          </Typography>
          <Typography variant="body1" style={{ marginBottom: 24 }}>
          Designed exclusively for Montessori schools, our web-based management platform seamlessly aligns with the Montessori philosophy of hands-on, activity-based learning. It streamlines curriculum planning and student progress tracking through a structured system of <b>Areas of Work, Activities, and Exercises, </b> empowering educators to assign personalized next steps in every child’s learning journey.
The platform includes a <b>Activity Planner</b> and comprehensive <b>ready-made lesson plans</b>—complete with objectives, materials, and key learning points—making lesson preparation efficient and consistent across classrooms.
Powerful administrative tools for <b>attendance, admissions, and assignment management</b>   simplify day-to-day operations, allowing teachers and staff to focus more on student development.
A dedicated <b>Parent Module</b> keeps families actively engaged with real-time updates on student activities, teacher observations, and important alerts—fostering a cohesive and collaborative school community.
Complemented by <b>mobile apps for teachers and parents,</b> the system ensures effortless access and communication—anytime, anywhere.

          </Typography>

          <Box display="flex" alignItems="center" mb={4}>
            <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "none" }}
              onClick={() => history.push("/montessori/schoolregistration")}
            >
              Get Started Today
            </Button>
            <Button
              component="a"
              href={demoVideo}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              style={{ textTransform: 'none', borderRadius: 8, marginLeft: 16  }}
              startIcon={<PlayArrowIcon />}
            >
              Watch Demo
            </Button>
          </Box>

          <Box display="flex" justifyContent="space-between" maxWidth={300}>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>15+</Typography>
              <Typography variant="caption">Schools</Typography>
            </Box>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>1000+</Typography>
              <Typography variant="caption">Students</Typography>
            </Box>
            <Box>
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>100+</Typography>
              <Typography variant="caption">Teachers</Typography>
            </Box>
          </Box>
        </Grid>

        {/* Right Image */}
        <Grid item xs={12} md={6}>
          <Box
            style={{
              borderRadius: 16,
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              position: 'relative',
              width: '84%',
              height:'400px'
            }}
          >
            <img
                src="/images/hero.png"
                alt="Kids Illustration"
                style={{ maxWidth: "100%", height: "400px", width: "600px", borderRadius: "10px" }}
              />
            <Box
              style={{
                position: 'absolute',
                bottom: 8,
                right: 8,
                backgroundColor: 'white',
                padding: '4px 8px',
                borderRadius: 4,
                fontSize: 12,
                color: 'red',
                fontWeight: 'bold',
              }}
            >
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeroSection;
